import ExodusModule from '@exodus/module';
import { createApprove } from '@exodus/ethereum-api';
import { isEthereumLikeToken } from '@exodus/ethereum-lib';
const MODULE_ID = 'exchangeApproveTokens';
export class ExchangeApproveTokens extends ExodusModule {
    #addressProvider;
    #exchangeAssets;
    #feeMonitors;
    #walletAccounts;
    #txSend;
    constructor(params) {
        super({ MODULE_ID, logger: params.logger });
        this.#addressProvider = params.addressProvider;
        this.#exchangeAssets = params.exchangeAssets;
        this.#feeMonitors = params.feeMonitors;
        this.#txSend = params.txSend;
        this.#walletAccounts = params.walletAccounts;
    }
    approveTokens = async ({ spenderAddress, assetId, approveAmount, walletAccount, }) => {
        const asset = this.#exchangeAssets.getAsset({ assetId });
        if (!isEthereumLikeToken(asset)) {
            throw new TypeError('Only Ethereum-like tokens are supported');
        }
        const receiveAddress = await this.#addressProvider.getReceiveAddress({
            assetName: asset.name,
            walletAccount: this.#walletAccounts.get(walletAccount),
        });
        const fromAddress = receiveAddress.toString();
        const approve = createApprove({
            sendTx: ({ asset, ...args }) => this.#txSend({ assetName: asset, ...args }),
        });
        const txData = asset.contract.approve.build(spenderAddress, approveAmount.toBaseString({ unit: false }));
        const feeData = await this.#feeMonitors.getFeeData({ assetName: asset.baseAssetName });
        const { txId } = await approve({
            walletAccount,
            fromAddress,
            spenderAddress,
            asset,
            feeData,
            feeAmount: asset.feeAsset.currency.baseUnit(0),
            approveAmount,
            txInput: txData,
            gasLimit: 0,
        });
        return txId;
    };
}
const exchangeApproveTokensFactory = (args) => new ExchangeApproveTokens({ ...args });
const exchangeApproveTokensModuleDefinition = {
    id: MODULE_ID,
    type: 'module',
    factory: exchangeApproveTokensFactory,
    dependencies: [
        'addressProvider',
        'exchangeAssets',
        'logger',
        'txSend',
        'walletAccounts',
        'feeMonitors',
    ],
};
export default exchangeApproveTokensModuleDefinition;
